/**
 * 初始化滚动动画效果（使用Animate.css）
 * @param {Object} options - 配置选项
 * @param {string|Array} options.selectors - 要观察的元素选择器
 * @param {string} options.animation - Animate.css动画类名（不含animate__前缀）
 * @param {number} options.staggerDelay - 依次进场延迟时间（毫秒）
 * @param {number} options.threshold - 触发阈值（0-1）
 * @param {string} options.rootMargin - 根元素边距
 * @param {string} options.hoverSelector - 悬停效果选择器
 */
export function initAnimateScroll(options = {}) {
  const {
    selectors = ".contact-info, .location-info, .feature-card, .culture-card",
    animation = "fadeInUp",
    staggerDelay = 100,
    threshold = 0.1,
    rootMargin = "0px 0px -50px 0px",
    hoverSelector = ".contact-item",
  } = options;

  document.addEventListener("DOMContentLoaded", function () {
    const elements =
      typeof selectors === "string"
        ? document.querySelectorAll(selectors)
        : [].concat(...selectors.map((s) => [...document.querySelectorAll(s)]));

    // 设置初始状态
    elements.forEach((el, index) => {
      el.style.opacity = "0";
      el.style.visibility = "hidden";
      el.classList.add("animate__animated"); // 预先添加基础类
    });

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const element = entry.target;
            const index = Array.from(elements).indexOf(element) + 1;
            console.log("className", element.className)
            console.log("index", index);

            // 使用setTimeout实现依次进场[7](@ref)
            setTimeout(() => {
              element.style.visibility = "visible";
              element.style.opacity = "1";
              element.classList.add(`animate__${animation}`);
            }, index * staggerDelay);

            observer.unobserve(element);
          }
        });
      },
      { threshold, rootMargin }
    );

    // 观察所有元素
    elements.forEach((el) => {
      observer.observe(el);
    });

    // 悬停效果（保持不变）
    if (hoverSelector) {
      document.querySelectorAll(hoverSelector).forEach((item) => {
        item.addEventListener("mouseenter", function () {
          this.style.transform = "translateX(10px)";
          this.style.transition = "transform 0.3s ease";
        });

        item.addEventListener("mouseleave", function () {
          this.style.transform = "translateX(0)";
        });
      });
    }
  });
}

// 基础使用：
// import { initAnimateScroll } from './animateScroll.js';

// // 简单使用
// initAnimateScroll();

// // 自定义配置
// initAnimateScroll({
//     selectors: ['.card', '.section-title', '.feature-item'],
//     animation: 'zoomIn', // Animate.css动画名
//     staggerDelay: 150,   // 每个元素延迟150ms
//     threshold: 0.2,      // 20%进入视口时触发
//     rootMargin: '0px 0px -100px 0px'
// });

/**
 * 增强版：支持更复杂的动画配置和依次进场
 */
export function initAdvancedAnimateScroll(options = {}) {
  const {
    selectors = ".animate-on-scroll",
    animation = "fadeInUp",
    staggerDelay = 100,
    threshold = 0.1,
    rootMargin = "0px 0px -50px 0px",
    useCustomDelay = true, // 是否使用自定义延迟
    resetOnLeave = false, // 离开视口时是否重置
    mobile = true, // 是否在移动设备启用
  } = options;

  // 检查是否在移动设备且禁用[1](@ref)
  if (
    !mobile &&
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    )
  ) {
    return;
  }

  document.addEventListener("DOMContentLoaded", function () {
    const elements =
      typeof selectors === "string"
        ? document.querySelectorAll(selectors)
        : [].concat(...selectors.map((s) => [...document.querySelectorAll(s)]));

    // 设置初始状态[2](@ref)
    elements.forEach((el, index) => {
      el.style.opacity = "0";
      el.style.visibility = "hidden";
      el.classList.add("animate__animated"); // 预先添加基础类
    });

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach((entry) => {
          const element = entry.target;

          if (entry.isIntersecting) {
            // 进入视口：显示并添加动画
            element.style.visibility = "visible";
            element.style.opacity = "1";
            element.classList.add(`animate__${animation}`);

            if (!resetOnLeave) {
              observer.unobserve(element);
            }
          } else if (resetOnLeave) {
            // 离开视口：重置动画（可选）
            element.classList.remove(`animate__${animation}`);
          }
        });
      },
      { threshold, rootMargin }
    );

    // 设置依次进场效果[7](@ref)
    elements.forEach((el, index) => {
      if (useCustomDelay) {
        el.style.animationDelay = `${index * staggerDelay}ms`;
      }
      observer.observe(el);
    });
  });
}

// 基础使用：
// import { initAdvancedAnimateScroll } from './animateScroll.js';

// // 支持重复动画和响应式
// initAdvancedAnimateScroll({
//     selectors: '.scroll-animate',
//     animation: 'slideInUp',
//     staggerDelay: 200,
//     resetOnLeave: true, // 滚动离开时重置，再次进入重新动画
//     mobile: false // 在移动设备禁用
// });



// WEBPACK FOOTER //
// ./src/utils/animateScroll.js